import { render, staticRenderFns } from "./add_products.vue?vue&type=template&id=7228c1df"
import script from "./add_products.vue?vue&type=script&lang=js"
export * from "./add_products.vue?vue&type=script&lang=js"
import style0 from "./add_products.vue?vue&type=style&index=0&id=7228c1df&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports